import get from 'lodash/get';
import { Button, SimpleText, Text } from 'platform-components';
import { getHints, getMe } from 'platform-components/src/components/user/selectors';
import { hasStudentValidLastNameAndFirstName } from 'platform-components/src/utils/input-validators';
import { InjectedProps as RouterPathProps, withRouterPath } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { Action, bindActionCreators, Dispatch } from 'redux';

import {
    getLoadingStatus,
    getSchoolCode,
    getStudents,
    getUsePassportAccounts,
} from 'common.components/classes/selectors';
import { isMesTeam } from 'common.components/classes/utils';
//@ts-ignore
// import StudentsControls from 'common.components/students/__controls/students__controls';
import { StudentsPassportButton } from 'common.components/students/__passport-button/students__passport-button';
import { StudentsTable } from 'common.components/students/__table/students__table';
import * as studentsActions from 'common.components/students/actions';
import { getControlsStatus, getNewStudent, getUsersConvertionStatus } from 'common.components/students/selectors';
import { teamBuilderActions } from 'common.components/team-builder/actions';
import { TEAM_BUILDER_ENTRY_STEPS } from 'common.components/team-builder/typings';
import * as userActions from 'common.components/user/actions';
import {
    getCanEditClass,
    getCurrentClass,
    getIsCurrentClassArchived,
    getIsCurrentClassSyncing,
    getIsInStudentRegistrationLinkExperiment,
    getIsStudentRegistrationLinkAvailableInTeam,
    getSchoolId,
} from 'common.components/user/selectors';
import { YM_LOCATION } from 'utils/ym-constants';

// @ts-ignore
import AddButton from '../__add-button/class__add-button';
import { AddSchoolPanel } from '../__add-school-panel/class__add-school-panel';
import { ClassStudentLink } from '../__student-link/class__student-link';
import { ClassStudentsAddManually } from '../__students-add-manually/class__students-add-manually';
import { ClassStudentsDescription } from '../__students-description/class__students-description';
import { ReduxTeacherStore } from '../../../typings';
import * as classActions from '../actions';

import './class__students.scss';

type StoreProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

interface HOCProps extends RouterPathProps {}

interface Props extends StoreProps, DispatchProps, HOCProps {}

interface State {
    shouldShowPassportAccounts: boolean;
}

export class ClassStudents extends React.Component<Props, State> {
    static displayName = 'ClassStudents';

    static contextTypes = {
        staticUrls: PropTypes.shape({
            labClassPrint: PropTypes.string.isRequired,
        }),
    };

    constructor(props: Props) {
        super(props);

        const { usePassportAccounts } = props;

        this.state = {
            shouldShowPassportAccounts: Boolean(usePassportAccounts),
        };
    }

    componentDidUpdate(prevProps: Props) {
        const { teamId: prevTeamId, usePassportAccounts: prevUsePassportAccounts } = prevProps;
        const { setStudentValidation, students, teamId: currentTeamId, usePassportAccounts } = this.props;

        if (prevUsePassportAccounts !== usePassportAccounts) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ shouldShowPassportAccounts: Boolean(usePassportAccounts) });
        }

        if (currentTeamId !== prevTeamId && students) {
            for (const student of students) {
                setStudentValidation(student.id, { correct: true, isMigrating: false });
            }
        }
    }
    context!: React.ContextType<React.Context<{ staticUrls: Record<string, string> }>>;

    handleAddNewStudent = () => {
        const { teamId, students, getNewStudentLoginRequest, startAddingNewStudentsList } = this.props;

        ym('reachGoal', 'teacher_my_students_student_add');

        if (teamId === null) {
            console.error('Unexpected null classId on adding new student');
            return;
        }

        if (!students || students.length === 0) {
            startAddingNewStudentsList();
        } else {
            getNewStudentLoginRequest(teamId);
        }
    };

    handleAddStudentList = () => {
        const { startAddingNewStudentsList } = this.props;

        startAddingNewStudentsList();
    };

    handleAddStudentFallback = () => {
        const { startAddingNewStudentsList } = this.props;

        startAddingNewStudentsList(TEAM_BUILDER_ENTRY_STEPS.FALLBACK_STUDENTS);
    };

    handleAddSchoolAndStudents = () => {
        const { startTeamBuilder } = this.props;

        startTeamBuilder({
            entryPoint: TEAM_BUILDER_ENTRY_STEPS.STUDENTS,
        });
    };

    handlePrintClick = () => {
        ym('reachGoal', 'teacher_my_students_print');

        const { teamId, getRouterPath, history } = this.props;
        const { shouldShowPassportAccounts } = this.state;
        const {
            staticUrls: { labClassPrint },
        } = this.context;

        const path = getRouterPath(labClassPrint, { classId: teamId });
        history.push(`${path}?usePassportAccounts=${shouldShowPassportAccounts}`);
    };

    handlePassportClick = () => {
        const { convertStudentsToPassport, setStudentValidation, students, teamId } = this.props;

        if (!students) {
            return;
        }

        let allStudentsValid = true;

        for (const student of students) {
            const isStudentNameValid = hasStudentValidLastNameAndFirstName(student);
            setStudentValidation(student.id, { correct: isStudentNameValid, isMigrating: true });

            allStudentsValid = allStudentsValid && isStudentNameValid;
        }

        if (students && teamId && allStudentsValid) {
            convertStudentsToPassport(teamId, students);
        }
    };

    getClassDescription = () => {
        const { canEdit, isArchiveClass } = this.props;

        const { shouldShowPassportAccounts } = this.state;

        if (isArchiveClass) {
            return canEdit ? 'class.classTable.archiveDescription' : 'class.classTable.archiveNonSupervisorDescription';
        }

        if (shouldShowPassportAccounts) {
            return 'class.classTable.passportDescription';
        }

        return 'class.classTable.remindStudentCode';
    };

    renderControls() {
        const { teamId, currentClass, showControls, syncTeamRequest, isCurrentClassSyncing, canEdit } = this.props;

        // школа теперь есть всегда
        // if (!schoolId) {
        //     return null;
        // }

        const externalClass = isMesTeam(currentClass);

        if (externalClass && teamId) {
            return (
                <Button
                    className="class__sync-button"
                    onClick={() => syncTeamRequest(teamId)}
                    progress={isCurrentClassSyncing}
                    view={Button.VIEW.SECONDARY}
                >
                    <SimpleText id="class.classTable.syncButton.text" />
                </Button>
            );
        }

        if (showControls) {
            return (
                <div className="class__students-controls">
                    {/*<StudentsControls classId={teamId} students={students} />*/}
                    {canEdit && (
                        <Button
                            accent={Button.ACCENT.NORMAL}
                            className="class__add-students-list"
                            onClick={this.handleAddStudentList}
                            view={Button.VIEW.ACTION}
                        >
                            <SimpleText id="class.addStudentsButton" />
                        </Button>
                    )}
                </div>
            );
        }

        return null;
    }

    // eslint-disable-next-line complexity
    renderAddButton = () => {
        const {
            canEdit,
            isArchiveClass,
            showControls,
            currentClass,
            isStudentRegistrationLinkAvailableInTeam,
            students,
        } = this.props;

        const hasSchoolInCurrentClass = Boolean(currentClass?.school_name);
        const shouldShowAddButton = !showControls && !isArchiveClass && canEdit && hasSchoolInCurrentClass;

        if (!shouldShowAddButton) {
            return null;
        }

        const hasStudents = students && students.length > 0;

        if (isStudentRegistrationLinkAvailableInTeam && !hasStudents) {
            return <ClassStudentsAddManually onClick={() => this.handleAddStudentFallback()} />;
        }

        const addStudentBtnText = hasSchoolInCurrentClass
            ? 'class.button.addNewStudent'
            : 'class.button.addNewStudent.withoutSchool';

        return (
            <AddButton
                mix="class__students-add-button"
                onClick={() => {
                    if (!hasSchoolInCurrentClass) {
                        ym('teacher_add_school', { location: 'my_classes' });
                    }

                    this.handleAddNewStudent();
                }}
                textId={addStudentBtnText}
            />
        );
    };

    handleAddStudentsSuccess = (studentsIds: Array<number>) => {
        const { teamId, me, students } = this.props;

        ym('reachGoal', 'student_created', {
            studentsNumber: studentsIds.length,
            team_id: teamId,
            user_id: me?.id,
            location: YM_LOCATION.CLASS,
            before_students_count: Array.isArray(students) ? students.length : 0,
        });
    };

    handleSwitch = () => {
        const { shouldShowPassportAccounts } = this.state;

        this.setState({ shouldShowPassportAccounts: !shouldShowPassportAccounts });
    };

    // eslint-disable-next-line complexity
    render() {
        const {
            teamId,
            code,
            isArchiveClass,
            isInStudentLinkExperiment,
            isStudentRegistrationLinkAvailableInTeam,
            loadingStatus,
            newStudent,
            convertionStatus,
            students,
            hints,
            usePassportAccounts,
            currentClass,
        } = this.props;

        const { shouldShowPassportAccounts } = this.state;
        const allowTeamsPassportMigration = Boolean(
            hints?.allow_teams_passport_migration && currentClass?.is_supervisor && !isArchiveClass
        );

        const descriptionId = this.getClassDescription();

        const mergedStudents = newStudent === null ? students : [...(students || []), newStudent];

        const showPassportAccounts = Boolean(usePassportAccounts);
        const showMigrationButton = allowTeamsPassportMigration && !showPassportAccounts;

        const shouldShowAccountSwitchControl = showPassportAccounts && Boolean(mergedStudents?.length);

        const hasStudents = !!students?.length;
        const shouldShowClassDescription = hasStudents || !isInStudentLinkExperiment;

        const hasSchoolInCurrentClass = Boolean(currentClass?.school_name);

        return (
            <React.Fragment>
                {!hasSchoolInCurrentClass && <AddSchoolPanel onAddSchool={this.handleAddSchoolAndStudents} />}
                {isStudentRegistrationLinkAvailableInTeam && hasSchoolInCurrentClass && <ClassStudentLink />}
                {shouldShowClassDescription && hasSchoolInCurrentClass && (
                    <ClassStudentsDescription
                        descriptionId={descriptionId}
                        handlePrint={this.handlePrintClick}
                        hasStudents={hasStudents}
                        isArchiveClass={isArchiveClass}
                        secondary={isStudentRegistrationLinkAvailableInTeam}
                        shouldShowPassportAccounts={shouldShowPassportAccounts}
                    />
                )}
                {showMigrationButton && students?.length && (
                    <div className="class__students-passport-convertation">
                        <span className="qa_team-students-passport-convertation">
                            <Text id="class.description.passportConvertation" type={Text.TYPE.MARKDOWN} />
                        </span>
                        <StudentsPassportButton
                            disabled={!students?.length}
                            loadingStatus={convertionStatus}
                            onClick={this.handlePassportClick}
                            textId="class.button.convertPassport"
                        />
                    </div>
                )}
                {teamId && (
                    <StudentsTable
                        code={code || ''}
                        loadingStatus={loadingStatus}
                        mix="class__students-table"
                        onSwitch={this.handleSwitch}
                        shouldShowAccountSwitchControl={shouldShowAccountSwitchControl}
                        showPassportAccountsInClass={shouldShowPassportAccounts}
                        students={mergedStudents}
                        teamId={teamId}
                    >
                        {this.renderAddButton()}
                    </StudentsTable>
                )}
                {this.renderControls()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: any) => {
    const classId: number | null = Number(get(ownProps, 'match.params.classId')) || null;

    return {
        teamId: classId,
        code: getSchoolCode(storeState, { classId }),
        canEdit: getCanEditClass(storeState, classId),
        isArchiveClass: getIsCurrentClassArchived(storeState, { classId }),
        currentClass: getCurrentClass(storeState, { classId }),
        isCurrentClassSyncing: getIsCurrentClassSyncing(storeState, { classId }),
        isInStudentLinkExperiment: getIsInStudentRegistrationLinkExperiment(storeState),
        isStudentRegistrationLinkAvailableInTeam: getIsStudentRegistrationLinkAvailableInTeam(storeState, { classId }),
        loadingStatus: getLoadingStatus(storeState, { classId }),
        convertionStatus: getUsersConvertionStatus(storeState),
        me: getMe(storeState),
        newStudent: getNewStudent(storeState),
        showControls: getControlsStatus(storeState),
        students: getStudents(storeState, { classId }),
        schoolId: getSchoolId(storeState),
        hints: getHints(storeState),
        usePassportAccounts: getUsePassportAccounts(storeState, { classId }),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    const { startAddingNewStudentsList } = classActions;
    const { getNewStudentLoginRequest, putUsersConvertToPassportRequest, setStudentValidation } = studentsActions;
    const { syncTeamRequest } = userActions;

    return bindActionCreators(
        {
            getNewStudentLoginRequest,
            startAddingNewStudentsList,
            syncTeamRequest,
            convertStudentsToPassport: putUsersConvertToPassportRequest,
            setStudentValidation,
            startTeamBuilder: teamBuilderActions.start,
        },
        dispatch
    );
};

export default withRouterPath(connect(mapStateToProps, mapDispatchToProps)(ClassStudents));
